function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/prefer-stateless-function */

/* Buttons needs to accept refs (dropdowns, etc) and a Component avoids the extra forwardRef wrapper */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import BaseButton from 'react-bootstrap/Button';
import Spinner from './Spinner';
import { useTheme } from './ThemeContext';
import styles from './Button.module.scss';
const propTypes = {
  /** Controls the visual style of the button. */
  theme: PropTypes.oneOfType([PropTypes.oneOf(['primary', 'secondary', 'danger', 'success', 'draft', 'expired', 'link', 'link-danger']), // escape hatch for specifying private-ish or deprecated themes
  PropTypes.string]),
  size: PropTypes.oneOf(['xlarge', 'large', 'medium']),

  /** Optionally specify an href to render a `<a>` tag styled as a button */
  href: PropTypes.string,

  /** Manually enable `:active` button styles */
  active: PropTypes.bool,

  /** Manually enable `:focus` button styles */
  focus: PropTypes.bool,

  /** Shows spinner and hides button content */
  busy: PropTypes.bool,

  /**
   * Control the underlying rendered element directly by passing in a valid
   * component type
   */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
const defaultProps = {
  theme: 'primary'
};
/**
 * A versatile `<button>` or `<a>` element, with varying visual styles. For a
 * simpler, unstyled, button, you can use `theme={null}` to opt out of default
 * color theme and more easily craft a one-off button style  (_IF_ needed).
 */

const Button = React.forwardRef(({
  theme,
  active,
  focus,
  busy,
  className,
  size,
  ...props
}, ref) => {
  const themeContext = useTheme();
  let themeStyles = styles[theme];
  let baseClass = styles.button;

  if (theme && theme.startsWith('link')) {
    baseClass = styles.linkButton;
  }

  if (!themeStyles) {
    themeStyles = styles[`${theme}-${themeContext}`];
  }

  return React.createElement(BaseButton, _extends({}, props, {
    ref: ref,
    className: classNames(className, baseClass, size && styles[size], focus && styles.focus, active && styles.active, themeStyles)
  }), busy && React.createElement(Spinner, {
    className: styles.spinner
  }), React.createElement("span", {
    className: classNames(styles.content, busy && styles.busy)
  }, props.children));
});
Button.displayName = 'Button';
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
export default Button;